import { render } from "./MoreORLess.vue?vue&type=template&id=45db62ed"
import script from "./MoreORLess.vue?vue&type=script&lang=js"
export * from "./MoreORLess.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__